import {
  AttachmentType,
  AttachmentUploadStatus,
} from '../../../../../../shared/editor/types';

/**
 * Maps task/call note attachment payloads (flat or nested `attachment`) into
 * `AttachmentType` for the shared read-only `Attachment` component.
 */
export function mapCallNoteAttachmentsToAttachmentTypes(
  attachments: unknown[] | undefined | null,
): AttachmentType[] {
  if (!attachments?.length) return [];

  return attachments.map((raw: any, index) => {
    const nested = raw?.attachment ?? raw;
    const id = nested?.id ?? raw?.id;
    const preSignedUrl = raw?.preSignedUrl ?? nested?.preSignedUrl;
    const sizeNumber =
      nested?.size != null ? parseInt(String(nested.size), 10) : 0;

    const base: AttachmentType & { preSignedUrl?: string } = {
      attachmentId: id,
      attachmentIdentifier: `call-note-attachment-${id ?? index}`,
      status: AttachmentUploadStatus.Existing,
      file: {
        name: nested?.name || '',
        type: nested?.mimeType || '',
        size: sizeNumber,
      },
      attachmentSize: sizeNumber,
    };

    if (preSignedUrl) {
      base.preSignedUrl = preSignedUrl;
    }

    return base;
  });
}
